<template>
    <div :class="'wrapper '+section">
        <!-- Sidebar -->
        <b-sidebar id="sidebar-moregiros" backdrop-variant="dark" no-header backdrop shadow>
            <template #default="{ hide }">
                <div class="py-3">
                    <b-card body-class="py-0" bg-variant="transparent">
                        <b-row>
                            <b-col cols="5">
                                <figure class="avatar avatar-60 bci no-shadow">
                                    <img :src="user.photo ? '/'+user.photo : '/img/user-default.png'"
                                         :alt="user.name + ' ' + user.lname" :title="user.name + ' ' + user.lname">
                                </figure>
                            </b-col>
                            <b-col cols="7" align-self="center">
                                <b-button size="sm" variant="light" class="btn-rounded float-right text-default" to="/admin/profile/information">
                                    <i class="material-icons mdi mdi-circle-edit-outline"></i>
                                </b-button>
                                <b-button size="sm" variant="light" class="btn-rounded float-right text-default mr-1" :to="{ path: '/admin/users/customers', query: { pending: 'true' } }" v-b-tooltip title="NUEVOS USUARIOS REGISTRADOS - Para aprobar/rechazar" style="position: relative;">
                                    <i class="material-icons mdi mdi-bell"></i>
                                    <span class="badge badge-danger" v-if="pendingUsersCount > 0" style="position: absolute; top: -5px; right: -5px; font-size: 10px; padding: 2px 5px;">{{ pendingUsersCount < 10 ? pendingUsersCount : '+9' }}</span>
                                </b-button>
                                <b-button size="sm" variant="light" class="btn-rounded float-right text-default mr-1" to="/admin/profile/security">
                                    <i class="material-icons mdi mdi-lock"></i>
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" class="pt-1">
                                <h5 class="mb-1 line-hide">{{ user.name }} {{ user.lname }}</h5>
                                <p class="text-mute small mb-0">Categoría: Administrador</p>
                                <p class="text-mute small">IP: {{ user.ip }}</p>
                            </b-col>
                        </b-row>
                    </b-card>
                    <hr>
                    <nav class="mb-3">
                        <b-nav vertical>
                            <template v-for="(item, index) in admin">
                                <template v-if="item.children">
                                    <b-nav-item v-b-toggle="'open-'+index">
                                        <i :class="'material-icons mdi mdi-'+item.icon"></i>
                                        <span>{{ item.text }}</span>
                                        <i class="material-icons when-open float-right">arrow_drop_up</i>
                                        <i class="material-icons when-closed float-right">arrow_drop_down</i>
                                    </b-nav-item>
                                    <b-collapse :id="'open-'+index">
                                        <b-card body-class="p-0" bg-variant="transparent">
                                            <template v-for="subitem in item.children">
                                                <b-nav-item class="pl-3" active-class="children" exact-active-class="nav-exact" :to="'/'+(user.role === 'Partner' ? 'partner' : 'admin')+'/'+item.link+'/'+subitem.link">
                                                    <i :class="'material-icons mdi mdi-'+subitem.icon"></i>
                                                    <span>{{ subitem.text }}</span>
                                                </b-nav-item>
                                            </template>
                                        </b-card>
                                    </b-collapse>
                                </template>
                                <b-nav-item exact-active-class="nav-exact" :to="'/admin/'+item.link" v-else-if="!item.adminOnly || user.role === 'Administrator'">
                                    <i :class="'material-icons mdi mdi-'+item.icon"></i>
                                    <span>{{ item.text }}</span>
                                </b-nav-item>
                            </template>
                            <b-nav-item exact-active-class="nav-exact" @click="logout">
                                <i class="material-icons mdi mdi-close-circle"></i>
                                <span>Cerrar Sesión</span>
                            </b-nav-item>
                        </b-nav>
                    </nav>
                </div>
            </template>
        </b-sidebar>
        <!-- Sidebar ends -->
        <!-- header -->
        <div class="header shadow">
            <b-row no-gutters>
                <b-col cols="auto">
                    <b-button variant="link" class="text-dark" v-b-toggle.sidebar-moregiros>
                        <i class="material-icons">menu</i>
                    </b-button>
                </b-col>
                <b-col class="text-center">
                    <img :src="logo" alt="logo-moregiros" class="header-logo py-0">
                </b-col>
                <b-col cols="auto">
                    <b-button variant="link" to="/admin/checker/pending" class="text-dark position-relative">
                        <i class="material-icons-outlined">shield</i>
                        <span class="counts">{{ count < 10 ? count : '+9' }}</span>
                    </b-button>
                    <b-button variant="link" to="/admin/compliance/alerts" class="text-danger position-relative" v-if="complianceAlertsCount > 0 && user.role === 'Administrator'" v-b-tooltip title="Alertas de Cumplimiento AML">
                        <i class="material-icons-outlined">warning</i>
                        <span class="counts" style="background:#dc3545;">{{ complianceAlertsCount < 10 ? complianceAlertsCount : '+9' }}</span>
                    </b-button>
                </b-col>
            </b-row>
        </div>
        <!-- header ends -->
        <transition name="fade" mode="out-in">
            <router-view
                :user="user"
                @success="update"
                @loader="hideLoader"
                @section="getSection"
            ></router-view>
        </transition>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
    name: "AdminComponent",
    data: () => ({
        logo: '/img/logo_header.png',
        section: '',
        back: false,
        count: 0,
        pendingUsersCount: 0,
        complianceAlertsCount: 0,
        user: {
            id: null,
            name: null,
            lname: null,
            phone: null,
            email: null,
            country: null,
            role: 'Administrator',
            status: null
        },
        admin: [
            {icon: 'view-dashboard', text: 'Inicio', link: 'home'},
            {icon: 'calculator', text: 'Cotizador', link: 'calculator'},
            {icon: 'eye-check', text: 'Verificador', link: 'checker', children: [
                    {icon: 'dots-horizontal-circle', text: 'Pendientes', link: 'pending'},
                    {icon: 'check-circle', text: 'Aprobadas', link: 'approved'},
                    {icon: 'close-circle', text: 'Rechazadas', link: 'rejected'}
                ]
            },
            {icon: 'cash-marker', text: 'Prefondeo', link: 'partner/balance'},
            {icon: 'cash-fast', text: 'Pagador', link: 'paymaster', children: [
                    {icon: 'cash-plus', text: 'Pendientes', link: 'pending'},
                    {icon: 'cash-sync', text: 'Aprobadas', link: 'approved'},
                    {icon: 'cash-check', text: 'Completadas', link: 'completed'},
                    {icon: 'cash-remove', text: 'Rechazadas', link: 'rejected'}
                ]
            },
            {icon: 'finance', text: 'Reportes', link: 'reports', children: [
                    {icon: 'chart-scatter-plot-hexbin', text: 'R. General', link: 'general'},
                    {icon: 'chart-gantt', text: 'R. Pendientes', link: 'pending'},
                    {icon: 'chart-pie', text: 'R. Devoluciones', link: 'returns'},
                    {icon: 'credit-card-multiple', text: 'R. TransBank', link: 'transbank'},
                    {icon: 'wallet', text: 'R. Prefondeo', link: 'partner/balance'},
                    {icon: 'wallet-bifold', text: 'R. Corresponsales', link: 'payers/balance'},
                    {icon: 'receipt-text', text: 'R. Facturación', link: 'invoices'},
                    {icon: 'account-cash', text: 'R. Agente', link: 'agente'}
                ]
            },
            {icon: 'lifebuoy', text: 'Soporte', link: 'support', children: [
                    {icon: 'check-network', text: 'Tickets Abiertos', link: 'open'},
                    {icon: 'close-network', text: 'Tickets Cerrados', link: 'close'}
                ]
            },
            {icon: 'account-group', text: 'Usuarios', link: 'users', children: [
                    {icon: 'account-heart', text: 'Clientes', link: 'customers'},
                    {icon: 'account-star', text: 'Empleados', link: 'staff'},
                    {icon: 'bank-check', text: 'Agentes', link: 'partners'},
                    {icon: 'cash-register', text: 'Cajeros', link: 'cashiers'}
                ]
            },
            {icon: 'shield-alert', text: 'Cumplimiento', link: 'compliance/alerts', adminOnly: true},
            {icon: 'cog-transfer', text: 'Ajustes', link: 'settings', children: [
                    {icon: 'cash-check', text: 'Tasas de Cambio', link: 'rate'},
                    {icon: 'sack-percent', text: 'Tarifa', link: 'fee'},
                    {icon: 'chart-box', text: 'Limites', link: 'limits'},
                    {icon: 'cash', text: 'Pagadores', link: 'payers'},
                    {icon: 'link-variant', text: 'Integraciones', link: 'integrations'},
                    {icon: 'bank', text: 'Cuentas de Bancos', link: 'bank-accounts'},
                    {icon: 'scale-balance', text: 'Legal', link: 'legal'},
                    {icon: 'ticket-percent', text: 'Códigos Promocionales', link: 'promo-codes'}
                ]
            }
        ]
    }),
    mounted() {
        this.user = Object.assign(this.user, this.auth);
        this.getIni();
        this.update();
    },
    computed: mapGetters({
        auth: 'user',
    }),
    watch: {
        'user.role'() {
            if (this.user.role !== 'Administrator') {
                if(this.user.role === 'Supervisor' || this.user.role === 'Partner' || this.user.role === 'Cashier') {
                    this.$router.push({ name: "PartnerHome" });
                } else {
                    this.$router.push({ name: "Home" });
                }
            } else {
                this.$emit('loader');
            }
        }
    },
    methods: {
        getIni() {
            axios.get('/api/admin/home/count').then((res) => {
                this.count = res.data.statistics.pending;
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
            axios.get('/api/admin/users/pending-count').then((res) => {
                if (res.data.status === 'success') {
                    this.pendingUsersCount = res.data.count;
                }
            }).catch(() => {});
            axios.get('/api/compliance/stats').then((res) => {
                this.complianceAlertsCount = res.data.new || 0;
            }).catch(() => {});
            this.timeout = setTimeout(this.getIni, 180000);
        },
        hideLoader() {
            if (this.user.role !== 'Customer') {
                this.$emit('loader');
            }
        },
        getSection(val) {
            this.section = val;
        },
        goBack() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/');
        },
        update() {
            axios.get('/api/profile').then((res) => {
                this.user = res.data.user;
                if (this.user.lname.includes(',')) {
                    this.user.lname = this.user.lname.replace(',', '');
                }
                this.$store.dispatch('setUser', res.data);
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
        },
        async logout() {
            await this.$store.dispatch("logout");
            this.$root.$bvToast.toast('Has cerrado sesión correctamente.', {
                title: 'Felicitaciones',
                variant: 'success',
                toaster: 'b-toaster-top-right',
                autoHideDelay: 5000,
                solid: true,
                appendToast: true
            });
            await this.$router.push({ name: "Login" });
        }
    },
    destroyed() {
        clearTimeout(this.timeout);
    }
}
</script>

<style scoped>
.bci {
    border: 1px solid #ddd;
}
</style>
